import {
  beABTestABTestSetWinner,
  beABTestCheckScheduleAbTestById,
  beABTestCleanABTest,
  beABTestGetABTestConfigById,
  beABTestGetABTestResultById,
  beABTestGetAggregateReportIDByABTestID,
  beABTestIsAbTestReschedulable,
  beABTestIsAbTestResumable,
  beABTestRescheduleAbTest,
  beABTestResumeAbTest,
  beABTestScheduleAbTestById,
  beABTestScheduleAbTestWinner,
  beABTestStopABTest,
  beABTestUpdateABTestConfig,
  beABTestUpdateABTestResults
} from 'Api/beABTestApi'
import { beEmailMessageApiGetMessageDetailsLazy } from 'Api/beEmailMessageApi'
import { BeListApiAddNewTag, BeListApiGetAllTags } from 'Api/BeListApi'
import {
  beSendGoExistsFailedSending,
  beSendGoGetFailedSendings
} from 'Api/beSendGoApi'
import { storeGet, STORE_KEY_ID_LIST } from 'mailup-react-helpers'
import { async } from 'regenerator-runtime'

export async function getABTestConfigByIdAction(idABTest) {
  const ret = await beABTestGetABTestConfigById(idABTest)
  return ret
}

export async function getAllTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await BeListApiGetAllTags(idList)
  return result
}

export async function addNewTag(pTagName) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await BeListApiAddNewTag(idList, pTagName)
  return result
}

export async function existsFailedSendingAction(idLists) {
  const result = await beSendGoExistsFailedSending(idLists)
  return result
}

export async function getFailedSendingsAction(params) {
  const result = beSendGoGetFailedSendings(params)
  return result
}

export async function getMessageDetailsAction(id) {
  const ret = await beEmailMessageApiGetMessageDetailsLazy(id)
  return ret
}

export async function getABTestResultByIdAction(idABTest) {
  return await beABTestGetABTestResultById(idABTest)
}

export async function updateABTestResultsAction(idABTest) {
  return await beABTestUpdateABTestResults(idABTest)
}

export async function updateABTestConfigAction(data) {
  return await beABTestUpdateABTestConfig(data)
}

export async function isAbTestReschedulableAction(idABTest) {
  return await beABTestIsAbTestReschedulable(idABTest)
}

export async function checkScheduleAbTestByIdAction(
  idAbTest,
  internalTimezoneCode,
  data
) {
  return await beABTestCheckScheduleAbTestById(
    idAbTest,
    internalTimezoneCode,
    data
  )
}

export async function rescheduleAbTestAction(idABTest) {
  return await beABTestRescheduleAbTest(idABTest)
}

export async function scheduleAbTestByIdAction(
  idAbTest,
  internalTimezoneCode,
  data
) {
  return await beABTestScheduleAbTestById(idAbTest, internalTimezoneCode, data)
}

export async function getAggregateReportIDByABTestIDAction(idABTest) {
  return await beABTestGetAggregateReportIDByABTestID(idABTest)
}

export async function isAbTestResumableAction(idABTest) {
  return await beABTestIsAbTestResumable(idABTest)
}

export async function resumeAbTestAction(idABTest) {
  return await beABTestResumeAbTest(idABTest)
}

export async function cleanABTestAction(idABTest) {
  return await beABTestCleanABTest(idABTest)
}

export async function stopABTestAction(idABTest) {
  return await beABTestStopABTest(idABTest)
}

export async function scheduleAbTestWinnerAction(idABTest, scheduleDateCTZ) {
  return await beABTestScheduleAbTestWinner(idABTest, scheduleDateCTZ)
}

export async function abTestSetWinnerAction(idABTest, idMessage) {
  return await beABTestABTestSetWinner(idABTest, idMessage)
}
